import api from '../config/axiosConfig';

export const LeadService = {
    get: async ({ token, pagina = 1, pageSize = 20, desde, hasta, searchByName, state, list }) => {
        try {
            const response = await api.get('/leads/', {
                headers: { Authorization: `Bearer ${token}` },
                params: { pagina, pageSize, desde, hasta, searchByName, state, list },
            });

            return {
                leads: response.data.leads || [],
                totalPaginas: response.data.totalPaginas || 1,
                totalRegistros: response.data.totalRegistros || 0,
            };
        } catch (error) {
            console.error('Error en LeadService.get:', error);
            throw error;
        }
    },
    getById: async ({ token, vid }) => {
        try {
            const response = await api.get(`/leads/${vid}`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            return {
                lead: response.data.lead || {},
            };
        } catch (error) {
            console.error('Error en LeadService.getById:', error);
            throw error;
        }
    },
    save: async ({ token, formData }) => {
        try {
            const response = await api.post('/leads', formData, {
                headers: { Authorization: `Bearer ${token}` },
            });
            return response.data;
        } catch (error) {
            console.error('Error en LeadService.save', error);
            throw error;
        }
    },
    exportar: async (token, filtros) => {
        try {
            const response = await api.post('/leads/exportar', filtros, {
                headers: { Authorization: `Bearer ${token}` },
                responseType: 'blob',
            });

            return response.data;
        } catch (error) {
            console.error('Error en LeadService.exportar', error);
            throw error;
        }
    },
    getStatistics: async ({ token, fechaInicio, fechaFin }) => {
        try {
            const response = await api.post(`/leads/count`, {
                fechaInicio: fechaInicio || null,
                fechaFin: fechaFin || null
            }, {
                headers: { Authorization: `Bearer ${token}` },
            });

            return response.data;
        } catch (error) {
            console.error('Error en LeadService.getStatistics:', error);
            throw error;
        }
    },
    exportarReporteVentasExcel: async (token, filtros) => {
        try {
            const response = await api.post('/ventas/exportarReporte', filtros, {
                headers: { Authorization: `Bearer ${token}` },
                responseType: 'blob',
            });

            return response.data;
        } catch (error) {
            console.error('Error en LeadService.exportarReporteVentasExcel:', error);
            throw error;
        }
    },
    fetchAvanceVentaPorId: async (token, id) => {
        try {
            const response = await api.get(`/ventas-avances/${id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            return response || {};
        } catch (error) {
            console.error('Error en LeadService.fetchAvanceVentaPorId:', error);
            throw error;
        }
    },
    fetchVentasReporte: async ({ token, pagina = 1, pageSize = 20, desde, hasta, nombre, vendedores, estado, regiones }) => {
        try {
            const response = await api.get('/ventas/reporte', {
                headers: { Authorization: `Bearer ${token}` },
                params: { pagina, pageSize, desde, hasta, nombre, vendedores, regiones, estado },
            });

            return {
                ventas: response.data.ventas || [],
                totalPaginas: response.data.totalPaginas || 1,
                totalRegistros: response.data.totalRegistros || 0,
            };
        } catch (error) {
            console.error('Error en LeadService.fetchVentasReporte:', error);
            throw error;
        }
    },
};
